import { IUser, SinglePerson } from '../../types/person.types'

export const ID_METLIFE_BENEFIT = 'e24da618-bd74-4e7b-9e58-5236a840ee87'

export const BASIC_PERSON_INITIAL_DATA: Partial<SinglePerson> = {
  email: '',
  phoneNumber: '',
  otherPhoneNumber: [],
  firstName: '',
  lastName: '',
  gender: '',
  otherGender: '',
  birthDate: '',
  preferredLanguage: '',
  street: '',
  city: '',
  state: '',
  postalCode: '',
  companies: [],
  source: undefined,
  haveHealthInsurance: '',
  coverageThroughTheState: '',
  pay20PerMonth: '',
  blackCarFund: [],
  rating: '',
  updatedAt: '',
  createdAt: '',
  otherEmail: [],
  createdBy: {} as IUser,
  updatedBy: {} as IUser,
}
